<template>
  <!-- flex justify center -->
  <v-card 
    flat
    class="mx-auto"
    style="width: 80%;"
  >
    <v-card-text>
      <v-col class="d-flex">
        <p
          class="mr-auto"
          style="line-height: 1.6;"
        >
          <span style="font-size:20px; color:#2B2B2B">
            デスクトップ通知
          </span>
          <br/>
          <span style="font-size:13px; color:#2B2B2B">
            デスクトップ通知をオンにすると、自分の{{$t('アイデア')}}が他の参加者に引用されたり、{{$t('プロジェクト')}}のチャットに返信やメンションされた際にデスクトップ上に通知が表示されます。
          </span>
        </p>
        <v-switch
          class="mt-0"
          v-model="notifyPush"
          :disabled="!isAuthed"
          @change="updatePushNotify"
        ></v-switch>
        <template v-slot:label>
          <v-progress-circular
            indeterminate
            :value="0"
            size="24"
            class="ml-2"
          ></v-progress-circular>
        </template>
      </v-col>
      <v-col class="d-flex">
        <p
          class="mr-auto"
          style="line-height: 1.6;"
        >
          <span style="font-size:20px; color:#2B2B2B">
            メール通知
          </span>
          <br/>
          <span style="font-size:13px; color:#2B2B2B">
            メール通知をオンにすると、自治体職員からのお知らせなどがメールで届きます。
          </span>
          <span v-if="!emailNotifyEnabled">（無効です）</span>
        </p>
        <v-switch
          class="mt-0"
          v-model="notifyMail"
          :disabled="!isAuthed||!emailNotifyEnabled"
          @change="updateMailNotify"
        ></v-switch>
      </v-col>
      <v-col class="d-flex">
        <div class="mr-auto">
          <p
            style="line-height: 1.6;"
          >
            <span style="font-size:20px; color:#2B2B2B">
              LINE通知
            </span>
            <br/>
            <span style="font-size:13px; color:#2B2B2B">
              LINE通知をオンにすると、通知用公式ラインから通知が届きます。
            </span>
            <span v-if="!lineNotifyEnabled">（無効です）</span>
          </p>
          <div v-if="lineNotifyEnabled&&!lineAdded">
            <p style="font-size:13px; color:#2B2B2B">
              ※公式LINEを友だち追加していないと通知されません。<br/>以下のボタンから公式LINEを友だち追加してください。
            </p>
            <lineFriendAddButton @updateLineAddedStatus="updateLineAddedStatus" />
          </div>
        </div>
        <v-switch
          class="mt-0"
          v-model="notifyLine"
          :disabled="!isAuthed||!lineNotifyEnabled||!lineAdded"
          @change="updateLineNotify"
        ></v-switch>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
// firestoreをインポート
import firebase from "firebase/app"
import "firebase/firestore"
import 'firebase/messaging'
import 'firebase/functions'
import lineFriendAddButton from './auth/parts/lineFriendAddButton.vue'

export default {
  components: { lineFriendAddButton },
  name: 'NotifySetting',
  data() {
    return {
      notifyPush: false,
      notifyMail: false,
      notifyLine: false,
      lineAdded: true,
    }
  },
  created() {
    // TODO: 次の行のコメントアウトを消す！！
    // this.updateData({isActive: true})
    this.checkUpdate()
  },
  mounted() {
    if (this.lineNotifyEnabled) {
      const checkIfLineAdded = firebase.functions().httpsCallable('checkIfUserAlreadyAddLineFriend')
      checkIfLineAdded({}).then(({data}) => {
        this.lineAdded = data.isFriend;
        if (!data.isFriend) {
          this.updateData({notifyLine: false})
        }
      })
    }
  },
  methods: {
    updateLineAddedStatus() {
      // 5秒に一回、回し続ける。 isFriendがtrueになったら終了
      const checkIfLineAdded = firebase.functions().httpsCallable('checkIfUserAlreadyAddLineFriend')
      const interval = setInterval(() => {
        checkIfLineAdded({}).then(({data}) => {
          this.lineAdded = data.isFriend;
          if (data.isFriend) {
            clearInterval(interval)
          }
        })
      }, 5000)
    },
    checkUpdate() {
      firebase.firestore().collection('userConfig').doc(this.uid).onSnapshot((doc) => {
        const data = doc.data()
        this.notifyPush = data?.notifyPush || false
        this.notifyMail = data?.notifyMail || false
        this.notifyLine = data?.notifyLine || false
      })
    },
    updateData(value) {
      // keyはstring, valueは実際に入れる値
      firebase.firestore().collection('userConfig').doc(this.uid).set(
        {
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          ...value
        },
        { merge: true }
      )
    },
    updatePushNotify() {
      if (this.notifyPush) {
        const messaging = firebase.messaging();
        const vapidKey = process.env.VUE_APP_FIREBASE_MESSAGING_KEY;
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            messaging.getToken(messaging, vapidKey)
              .then(async (currentToken) => {
                this.updateData({
                  notifyPush: true,
                  pushToken: currentToken,
                  pushSource: window.location.href,
                })
              })
              .catch((e) => {
                console.error('error at updatePushNotify, content:', e);
                this.notifyPush = false
                alert('エラーが発生しました。ご不便おかけし申し訳ありません。この事象は開発チームが調査・修正いたします。')
              });
            } else {
            this.notifyPush = false
            alert('ブラウザの設定で通知設定が拒否されています。')
          }
        });
      } else {
        this.updateData({
          notifyPush: false,
          pushToken: firebase.firestore.FieldValue.delete(),
          pushSource: firebase.firestore.FieldValue.delete(),
        })
      }
    },
    updateMailNotify() {
      this.updateData({notifyMail: this.notifyMail})
    },
    updateLineNotify() {
      this.updateData({notifyLine: this.notifyLine})
    },
  },
  computed: {
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    uid() {
      return this.$store.state.auth.user.uid || '';
    },
    myemail() {
      return this.$store.state.auth.user.emailVerified && this.$store.state.auth.user.email || false;
    },
    emailNotifyEnabled() {
      return this.myemail && !this.myemail.endsWith("liqlid.local");
    },
    lineNotifyEnabled() {
      return !!(Number(process.env.VUE_APP_FEATURE_NOTIFY_LINE || 0) && this.$store.state.auth.user.line)
    },
  },
}
</script>